// extracted by mini-css-extract-plugin
module.exports = {"header":"header--1HIB-","container":"container--2H5k1"};